var map = {
	"./UBS_Logo.svg": 6131,
	"./_dados bancarios.svg": 4722,
	"./_dados da empresa.svg": 784,
	"./_dados financeiros.svg": 2105,
	"./_declaracoes.svg": 5215,
	"./_documentos.svg": 5267,
	"./_endereco.svg": 7419,
	"./_fatca.svg": 5576,
	"./_procuradores.svg": 3449,
	"./_produtos.svg": 2064,
	"./_representantes.svg": 7954,
	"./arrow.svg": 619,
	"./cadeado_com_fundo.svg": 7098,
	"./eye-crossed.svg": 4767,
	"./eye.svg": 461,
	"./gmail.svg": 54,
	"./ico-edit.svg": 1125,
	"./ico-refresh.svg": 7608,
	"./ico-trash.svg": 7942,
	"./logo-oslo.svg": 5343,
	"./logo.svg": 2575,
	"./logo/oslo.svg": 1466,
	"./logo/solis.svg": 576,
	"./outlook.svg": 4932,
	"./pendente.svg": 7623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9664;